import React from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {MiLegajoContextProvider} from './MiLegajoPageContext'
import {MiLegajoHeader} from './components/MiLegajoHeader'
import {MiLegajoTable} from './components/MiLegajoTable'

const legajoBreadcrumbs = [
  {
    title: 'Mi Legajo',
    path: '/mi-legajo',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const MiLegajoPage: React.FC = () => {
  return (
    <MiLegajoContextProvider>
      <BasicBreadcrumbs breadcrumbs={legajoBreadcrumbs} fallbackTitle='Documentos' />
      <KTCard className='min-h-700px'>
        <MiLegajoHeader />
        <MiLegajoTable />
      </KTCard>
    </MiLegajoContextProvider>
  )
}

export {MiLegajoPage}
